import { render } from "./AccountWalletModal.vue?vue&type=template&id=4d394a9f&ts=true"
import script from "./AccountWalletModal.vue?vue&type=script&lang=ts"
export * from "./AccountWalletModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__